import React from 'react';
import {
  bool, func, number, shape, string
} from 'prop-types';
import { ResponsiveAssistant } from './components/ResponsiveAssistant';
import { AssistantHeader } from './components/AssistantHeader';

// Master (pre-unification) assistant content. Drawer state, the FAB and all of
// their functionality live in AppSwitch; this tree only renders the assistant
// content for the master magic-apron build, driven by the props AppSwitch passes.
export const App = ({
  drawerState = 'CLOSED',
  offsetMargin,
  enableMiniDrawer = true,
  handleClose,
  handleOpen,
  updateDrawerState,
  updateSession,
}) => {
  if (drawerState === 'CLOSED') return null;

  return (
    <ResponsiveAssistant
      drawerState={drawerState}
      setDrawerState={(newDrawerState) => {
        if (newDrawerState === 'CLOSED') handleClose();
        if (newDrawerState === 'OPEN') handleOpen();
        if (newDrawerState === 'MINIMIZED') {
          updateDrawerState(enableMiniDrawer ? 'MINIMIZED' : 'CLOSED');
          updateSession({ shouldAutoOpen: true });
        }
      }}
      offsetMargin={offsetMargin}
    >
      {drawerState === 'OPEN'
        && <AssistantHeader onClose={handleClose} />}
    </ResponsiveAssistant>
  );
};

App.propTypes = {
  drawerState: string,
  offsetMargin: number.isRequired,
  enableMiniDrawer: bool,
  handleClose: func.isRequired,
  handleOpen: func.isRequired,
  updateDrawerState: func.isRequired,
  updateSession: func.isRequired,
};
